import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import Navbar from './Components/Navbar/Navbar';
import Footer from './Components/Footer/Footer';

import Home from './Pages/Home/Home';
import About from './Pages/About/About';
import Services from './Pages/Services/Services';
import Contact from './Pages/Contact/Contact';
import Blog from './Pages/Blog/Blog';
import Checkout from './Components/Checkout/Checkout';

import LogoDesign from './Pages/Services/LogoDesign';
import BusinessCards from './Pages/Services/BusinessCards';
import WebDesign from './Pages/Services/WebDesign';
import SocialMedia from './Pages/Services/SocialMedia';
import SEO from './Pages/Services/SEO';
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> 
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/logo-design" element={<LogoDesign />} />
        <Route path="/services/web-design" element={<WebDesign />} />
        <Route path="/services/business-cards" element={<BusinessCards />} />
        <Route path="/services/seo-marketing" element={<SEO />} />
        <Route path="/services/social-media-design" element={<SocialMedia />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/checkout" element={<Checkout />} />                      
      </Routes>
          <Footer />
    </BrowserRouter>
  );
}

export default App;
